import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const ofLabel = {
  en: 'of',
  id: 'dari'
}

const resultLabel = {
  en: 'results',
  id: 'hasil'
}

const PaginationInfo = ({
  currentPageStart,
  currentPageEnd,
  totalData
}) => {
  const language = useSelector(state => state.system.language)
  const currentPageStartRendered = totalData === 0 ? 0 : currentPageStart
  const currentPageEndRendered = totalData === 0 ? 0 : currentPageEnd

  return (
    <div className="font-medium" style={{color: '#444'}}>
      {currentPageStartRendered}-{currentPageEndRendered} {ofLabel[language.name]} {totalData} {resultLabel[language.name]}
    </div>
  )
}

PaginationInfo.propTypes = {
  currentPageStart: PropTypes.number,
  currentPageEnd: PropTypes.number,
  totalData: PropTypes.number
}

PaginationInfo.defaultProps = {
  currentPageStart: 0,
  currentPageEnd: 0,
  totalData: 0
}

export default PaginationInfo
